import MaintenanceC from "../../components/Maintenance";
import React from "react";

function Maintenance() {
    return <MaintenanceC reason=""/>
}

export default Maintenance;
